<template>
    <Layout>
        <!-- Page heading -->
        <div class="relative bg-indigo-800">
            <div class="absolute inset-0">
                <img class="h-full w-full object-cover" src="/images/offers.jpeg" alt="" />

                <div class="absolute inset-0 bg-gray-800 mix-blend-multiply" aria-hidden="true" />
            </div>

            <div class="relative mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-32 lg:px-8 lg:py-24">
                <h1 class="text-xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-3xl">
                    {{ $t('All internships') }}
                </h1>
            </div>
        </div>

        <!-- Search form -->
        <div class="z-10 mx-auto max-w-4xl bg-gray-100 lg:relative lg:top-0 lg:-mt-10 lg:bg-transparent">
            <form class="flex space-x-4 p-2 lg:space-x-6 lg:p-0" @submit.prevent="search()">
                <input
                    type="text"
                    class="w-full rounded-xl bg-white p-4 shadow"
                    v-model="query"
                    :placeholder="$t('Search by internship type or company name')"
                />

                <button class="h-14 rounded-xl bg-gray-800 px-4 text-white hover:bg-gray-700 md:h-20 lg:px-10">{{ $t('Search') }}</button>
            </form>
        </div>

        <!-- Internships grid -->
        <div class="mx-auto max-w-7xl px-4 py-10 lg:px-8">
            <p v-if="props.error">Une erreur s'est produite, veuillez réessayer.</p>

            <div v-else class="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
                <InternshipCard v-for="internship in props.internships" :key="internship.title" :internship="internship" />
            </div>
        </div>
    </Layout>
</template>

<script setup>
    import InternshipCard from '@/Partials/InternshipCard';
    import { Inertia } from '@inertiajs/inertia';
    import { usePage } from '@inertiajs/inertia-vue3';
    import { ref } from 'vue';

    const props = defineProps({
        error: Boolean,
        internships: Array,
        search: String,
    });

    const query = ref(props.search ?? '');

    function search() {
        let params = {};

        if (query.value) {
            params.recherche = query.value;
        } else {
            params.recherche = '';
        }

        Inertia.visit(usePage().props.value.url, {
            data: params,
        });
    }
</script>
